import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Doctors from "@/components/Doctors";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { whatsappLink } from "@/lib/clinic";

export default function LandingPage() {
    return (
        <div className="min-h-screen bg-[#FDFBF7] text-[#1A221F]" data-testid="landing-page">
            <Navbar />
            <main>
                <Hero />
                <About />
                <Services />
                <Doctors />
                <Gallery />
                <Testimonials />
                <FAQ />
                <Contact />
            </main>
            <Footer />

            {/* Floating WhatsApp button */}
            <motion.a
                href={whatsappLink()}
                target="_blank"
                rel="noreferrer"
                initial={{ scale: 0, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ delay: 1.2, type: "spring", stiffness: 200 }}
                whileHover={{ scale: 1.08 }}
                className="fixed bottom-6 left-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.4)]"
                aria-label="Chat on WhatsApp"
                data-testid="floating-whatsapp"
            >
                <MessageCircle className="w-6 h-6" />
                <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
            </motion.a>
        </div>
    );
}
